<template>
  <section>
    <div class="container">
      <div class="d-flex mt-5 mb-3 mb-md-5">
        <div class="position-relative movie-tabs">
          <router-link
            to
            :class="[
              'section-header-movie ',
              selectedFilter.tab !== 'now_showing' ? 'inactive' : '',
            ]"
            @click.native="onHandleTabChange($event, 'now_showing')"
            >Now Showing</router-link
          >
          <!-- <img
            src="@/assets/img/gif/Mascots-popcorn-small.gif"
            alt
            class="home-gif-image new-changes-gif"
          /> -->
        </div>
        <div class="mx-4 mx-md-4 mx-lg-5"></div>
        <div class="position-relative movie-tabs">
          <router-link
            to
            :class="[
              'section-header-movie ',
              selectedFilter.tab !== 'coming_soon' ? 'inactive' : '',
            ]"
            @click.native="onHandleTabChange($event, 'coming_soon')"
            >Coming Soon</router-link
          >
          <!-- <img
            src="@/assets/img/gif/Mascots-momcorn-small.gif"
            alt
            class="home-gif-image new-changes-gif"
          /> -->
        </div>
      </div>
      <div class="movie-filter d-none d-md-block">
        <ul class="list-inline">
          <!-- <li class="list-inline-item hoverEffect">Trending</li> -->
          <li class="list-inline-item hoverEffect" @click="onHandleTopRated()">
            Top Rated
          </li>

          <li class="list-inline-item hoverEffect">
            <b-dropdown
              id="dropdown-1"
              :text="selectedGenreName"
              variant="none"
            >
              <b-dropdown-item
                v-for="(GenreItem, GenreIndex) in genreList"
                :key="GenreIndex + '_GENRE' + GenreItem.genre_id"
                @click="onHandleGenre($event, GenreItem)"
                >{{ GenreItem.genre_name }}</b-dropdown-item
              >
            </b-dropdown>
          </li>
          <li class="list-inline-item hoverEffect">
            <b-dropdown
              id="dropdown-1"
              :text="selectedLanguageName"
              variant="none"
            >
              <b-dropdown-item
                v-for="(LanguageItem, LanguageIndex) in languageList"
                :key="LanguageIndex + '_LANGUAGE' + LanguageItem.language"
                @click="onHandleLanguage($event, LanguageItem)"
                >{{ LanguageItem.language_name }}</b-dropdown-item
              >
            </b-dropdown>
          </li>
          <li class="list-inline-item hoverEffect">
            <b-dropdown
              id="dropdown-1"
              :text="selectedFormatName"
              variant="none"
            >
              <b-dropdown-item
                v-for="(FormatItem, FormatIndex) in formatList"
                :key="FormatIndex + '_FORMAT' + FormatItem.id"
                @click="onHandleFormat($event, FormatItem)"
                >{{ FormatItem.name }}</b-dropdown-item
              >
            </b-dropdown>
          </li>
        </ul>
      </div>
      <div class="row">
        <div v-if="movieloader" class="section-loader">
          <b-spinner label="Loading..."></b-spinner>
          <label>Loading...</label>
        </div>
        <template v-if="!movieloader && movies.length > 0">
          <div
            :key="movieKey"
            class="
              col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3
              px-md-2 px-lg-3 px-3
              evenSpacing
            "
            v-for="(movie, movieKey) in movies"
          >
            <div class="movie-listing-card">
              <!-- <div class="release-date" v-if="movie.Film_dtmOpeningDate">
                {{ movie && movie.Film_dtmOpeningDate }}
              </div> -->

              <div
                class="movie-card-img-box"
                @click="
                  $router.push({
                    name: 'Movie Details',
                    params: { movie_code: movie.Film_strCode },
                  })
                "
              >
                <img
                  v-lazy="IMAGE_URL + movie.image_path_1"
                  class="img-fluid"
                  alt
                />
              </div>

              <!-- SHOW ONLY ON MOBILE -->
              <div class="mobile-heart-btn d-md-none">
                <button
                  class="btn-like"
                  title="Like this movie"
                  @click="
                    getIsUserLogged
                      ? handleLikeMovie($event, movie.Film_strCode)
                      : onHandleOpenModal('signInModal')
                  "
                >
                  <b-icon
                    :icon="
                      movie.liked === 'Y' || movie.movie_liked
                        ? 'heart-fill'
                        : 'heart'
                    "
                    :variant="
                      movie.liked === 'Y' || movie.movie_liked
                        ? 'danger'
                        : 'secondary'
                    "
                  ></b-icon>
                  <span>{{ movie && movie.likes }}</span>
                </button>
              </div>
              <!-- SHOW ONLY ON MOBILE -->
              <div class="movie-content">
                <div class="movie-title">
                  {{
                    movie.Film_strCode
                      ? movie.Film_strTitle
                      : movie.csm_film_title
                  }}
                </div>

                <div
                  class="
                    movie-card-like-row
                    coming-soon-movie-card
                    d-none d-md-block
                  "
                >
                  <ul class="dot-list">
                    <li>{{ movie.language_name }}</li>
                    <li>{{ movie.genre_name }}</li>
                    <li>{{ movie.Film_strCensor }}</li>
                  </ul>

                  <button
                    class="btn-like"
                    title="Like this movie"
                    @click="
                      getIsUserLogged
                        ? handleLikeMovie($event, movie.Film_strCode)
                        : onHandleOpenModal('signInModal')
                    "
                  >
                    <b-icon
                      :icon="
                        movie.liked === 'Y' || movie.movie_liked
                          ? 'heart-fill'
                          : 'heart'
                      "
                      :variant="
                        movie.liked === 'Y' || movie.movie_liked
                          ? 'danger'
                          : 'secondary'
                      "
                    ></b-icon>
                    <span>{{ movie && movie.likes }}</span>
                  </button>
                </div>

                <!-- SHOW ONLY ON MOBILE -->
                <div class="d-md-none coming-soon-movie-card">
                  <ul class="dot-list">
                    <li>{{ movie.language_name }}</li>
                    <li>{{ movie.genre_name }}</li>
                    <li>{{ movie.Film_strCensor }}</li>
                  </ul>
                </div>
                <!-- SHOW ONLY ON MOBILE -->

                <div class="d-none d-md-block mt-3">
                  <div class="row">
                    <div
                      class="
                        col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6
                        mb-2 mb-sm-0
                        pr-sm-1
                      "
                    >
                      <a
                        data-fancybox
                        :href="movie.youtube_url"
                        class="btn btn-outline-primary w-100 px-1"
                        >Play Trailer</a
                      >
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 pl-sm-1"
                      v-if="movie.Film_strCode"
                    >
                      <router-link
                        to
                        @click.native="
                          () =>
                            $router.push({
                              name: 'Movie Details',
                              params: { movie_code: movie.Film_strCode },
                            })
                        "
                        class="btn btn-primary w-100 px-1 font-weight-bold"
                        >Book Ticket</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- <empty-state
          v-if="!movieloader && movies.length == 0"
          isClass="border-0"
          :emptyMessage="`No movies to show`"
          :isNeedTopSpace="true"
        /> -->
        <!-- :emptyImage="require('@/assets/img/icons/chat-message.svg')" -->
      </div>
      <div class="section-space-50"></div>
    </div>
    <!-- <applyFilters class="d-md-none" /> -->
    <template>
      <div class="d-md-none">
        <!-- MOBILE -->
        <section class="d-md-none">
          <!-- FILTER FOOTER -->
          <div
            class="mobile-footer"
            v-if="!filterSection"
            @click="showFilterSection"
          >
            <!-- <span class="font-weight-bold text-rose-gold mr-1">3</span> -->
            Apply Filters
            <img src="@/assets/img/icons/up-arrow-icon.svg" class="ml-2" alt />
          </div>
          <!-- FILTER FOOTER AFTER FILTER BOX OPEN -->
          <div
            class="mobile-filter-footer"
            v-if="filterSection"
            @click="showFilterSection"
          >
            <div class="mobile-filter-btn clear-btn">Clear All</div>
            <div class="mobile-filter-btn apply-btn">Apply Filters</div>
          </div>

          <!-- MOBILE FILTER POPUP -->
          <div class="mobile-Box" v-if="filterSection">
            <!-- MOBILE FILTER HEADER -->
            <div class="p-3 mobile-header">
              Choose Filter
              <span class="float-right" @click="closeFilterSection">
                <img src="@/assets/img/icons/close-white-icon.svg" alt />
              </span>
            </div>

            <div class="px-3 w-100">
              <div class="section-space-50"></div>
              <div class="section-space-25"></div>
              <div class="filter-box">
                <!-- LOOP FILTER SECTION -->
                <div class="mb-4">
                  <p class="filter-title">Movie Formats</p>
                  <ul class="list-inline filter-list">
                    <li
                      class="list-inline-item mb-2"
                      :class="formatIndex == 1 ? 'active' : ''"
                      v-for="(FormatItem, FormatIndex) in formatList"
                      :key="FormatIndex + '_FORMAT' + FormatItem.id"
                      @click="onHandleFormat($event, FormatItem)"
                    >
                      <span class="box">{{ FormatItem.name }}</span>
                    </li>
                  </ul>
                </div>

                <div class="mb-4">
                  <p class="filter-title">Languages</p>
                  <ul class="list-inline filter-list">
                    <li
                      class="list-inline-item mb-2"
                      :class="formatIndex == 0 ? 'active' : ''"
                      v-for="(LanguageItem, LanguageIndex) in languageList"
                      :key="LanguageIndex + '_LANGUAGE' + LanguageItem.language"
                      @click="onHandleLanguage($event, LanguageItem)"
                    >
                      <span class="box">{{ LanguageItem.language_name }}</span>
                    </li>
                  </ul>
                </div>

                <div class="mb-4">
                  <p class="filter-title">Genre</p>
                  <ul class="list-inline filter-list">
                    <li
                      class="list-inline-item mb-2"
                      :class="formatIndex == 4 ? 'active' : ''"
                      v-for="(GenreItem, GenreIndex) in genreList"
                      :key="GenreIndex + '_GENRE' + GenreItem.genre_id"
                      @click="onHandleGenre($event, GenreItem)"
                    >
                      <span class="box">{{ GenreItem.genre_name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="section-space-50"></div>
              <div class="section-space-25"></div>
            </div>
          </div>
        </section>
      </div>
    </template>
    <EmptyMovieState
      v-if="!movieloader && movies.length === 0"
      isClass="border-0"
      :emptyMessage="`No Movies Found`"
      :isNeedTopSpace="true"
    />
  </section>
</template>
<script>
import Vue from "vue";
import applyFilters from "@/components/partials/applyFilters";
import { mapState, mapGetters, mapActions } from "vuex";
import MovieService from "@/apiServices/MovieService";
import { IMAGEURL } from "@/config";

const fixedFilter = () => ({
  tab: "now_showing",
  genreName: "Genre",
  genreId: "",
  formatName: "Format",
  formatId: "",
  languageName: "Language",
  languageId: "",
  sort: null,
});

export default {
  data() {
    return {
      movieloader: false,
      IMAGE_URL: IMAGEURL,
      movieLiked: false,
      tabName: "now_showing",
      movies: [],
      selectedSort: "",
      selectedGenreID: null,
      selectedGenreName: "Genre",
      selectedLanguageID: null,
      selectedLanguageName: "Language",
      selectedFormatID: null,
      selectedFormatName: "Format",
      selectedFilter: fixedFilter(),
      genreList: [
        {
          genre_id: 0,
          genre_name: "All",
        },
      ],
      languageList: [
        {
          language: 0,
          language_name: "All",
        },
      ],
      formatList: [
        { name: "All", id: 0 },
        { name: "2D", id: 1 },
        { name: "3D", id: 2 },
        // { name: "Maximum", id: 3 },
      ],
      filterSection: false,
    };
  },
  components: {
    applyFilters,
  },
  beforeMount() {
    // this.onGetMovieList();
    this.getMovies();
    this.getMovieLanguages();
    this.getMovieGenres();
    // this.getNowShowingMovies();
    // this.getTopFilter();
  },
  computed: {
    ...mapGetters(["getIsUserLogged"]),
  },
  methods: {
    async handleLikeMovie(e, movie_code) {
      if (movie_code) {
        const response = await MovieService.LikeMovie({ movie_code });
        const { data } = response;
        if (data && data.status) {
          if (data.data === "unliked") {
            const index = this.movies.findIndex(
              (movie) => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              this.movies[index].movie_liked = false;
              this.movies[index].liked = "N";
              this.$forceUpdate();
            }
          } else {
            const index = this.movies.findIndex(
              (movie) => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              this.movies[index].movie_liked = true;
              this.$forceUpdate();
            }
          }
        }
      }
    },
    ...mapActions([
      "onGetMovieList",
      "onResetMovieStoreState",
      "onHandleOpenModal",
    ]),
    resetFilters: function () {
      this.selectedFilter = {
        ...fixedFilter(),
        tab: "now_showing",
      };
    },
    onHandleTopRated() {
      // this.selectedFilter = fixedFilter();
      // this.selectedFilter.sort = 1;
      this.selectedSort = "top_rated";
      this.getMovies();
    },
    onHandleTabChange(event, tabName) {
      this.selectedFilter = {
        ...fixedFilter(),
        tab: tabName,
      };
      this.tabName = tabName;
      if (tabName === "now_showing") {
        this.getMovies(this.selectedFilter);
      } else if (tabName === "coming_soon") {
        this.getComingSoonMovies();
      }
    },
    onHandleGenre(event, item) {
      // this.selectedFilter = fixedFilter();
      // this.selectedFilter.genreName = item.genre_name;
      // this.selectedFilter.genreId = item.genre_id;
      this.selectedGenreID = item.genre_id;
      this.selectedGenreName = item.genre_name;
      this.getMovies();
    },
    onHandleLanguage(event, item) {
      // this.selectedFilter = fixedFilter();
      // this.selectedFilter.languageName = item.language_name;
      // this.selectedFilter.languageId = item.language;
      // this.getMovies(this.selectedFilter);
      console.log(item);
      this.selectedLanguageID = item.language;
      this.selectedLanguageName = item.language_name;
      this.getMovies();
    },
    onHandleFormat(event, item) {
      // this.selectedFilter = fixedFilter();
      // this.selectedFilter.formatName = item.name;
      // this.selectedFilter.formatId = item.id;
      // this.getMovies(this.selectedFilter);
      this.selectedFormatID = item.id;
      this.selectedFormatName = item.name;
      this.getMovies();
    },
    getTopFilter() {
      // call service
      // data
      // generLis, languages, formats
    },
    async getMovieLanguages() {
      const response = await MovieService.GetMovieLanguages();
      const { data } = response;
      if (data && data.status) {
        // this.languageList = data.data;
        data.data.map((language) => this.languageList.push(language));
      }
    },
    async getMovieGenres() {
      const response = await MovieService.GetMovieGenres();
      const { data } = response;
      if (data && data.status) {
        // this.genreList = data.data;
        data.data.map((genre) => this.genreList.push(genre));
      }
    },
    async getMovies(params = {}) {
      let loader = Vue.$loading.show();
      try {
        this.movieloader = true;
        let payload = {
          topTab: this.selectedFilter.tab,
          sort: this.selectedSort || null,
          genre: this.selectedGenreID || null,
          language: this.selectedLanguageID || null,
          format: this.selectedFormatID || null,
          // filter: "",
          // filterValue: "",
        };
        const { data } = await MovieService.GetMovies(payload);
        if (data && data.status) {
          this.movies = data.data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.movieloader = false;
        loader.hide();
      }
    },
    async getComingSoonMovies(params = {}) {
      let loader = Vue.$loading.show();
      try {
        this.movieloader = true;
        this.movies = [];
        const response = await MovieService.ComingSoonMovies(params);
        const { data } = response;
        if (data && data.status) {
          this.movies = data.data;
        }
      } catch (error) {
        console.log("Error getting Coming Soon movies", error);
      } finally {
        this.movieloader = false;
        loader.hide();
      }
    },
    showFilterSection: function () {
      this.filterSection = !this.filterSection;
    },
    closeFilterSection: function () {
      this.filterSection = false;
    },
  },
  destroyed() {
    // if needed reset your store
    //this.onResetMovieStoreState()
  },
};
</script>
<style>
.section-header-movie{
  background: var(--rose-linear-gradient);
  color: var(--bg-dark-2);
  padding: 0.8rem 1rem;
  border-radius: 5px;
}
.section-header-movie:hover{
  color: #fff;
}
.section-header-movie.inactive{
  background-color: transparent;
  color: #8f5c4d;
  padding: 0.8rem 1rem;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/movies.vue